import { render, staticRenderFns } from "./PhonesFiltersDropdowns.vue?vue&type=template&id=15562de5&scoped=true"
import script from "./PhonesFiltersDropdowns.vue?vue&type=script&lang=ts"
export * from "./PhonesFiltersDropdowns.vue?vue&type=script&lang=ts"
import style0 from "./PhonesFiltersDropdowns.vue?vue&type=style&index=0&id=15562de5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15562de5",
  null
  
)

export default component.exports